import React, { forwardRef } from 'react';

import RTCView, { RTCIOSPIPOptions, RTCVideoViewProps } from './RTCView.web';

export type RTCPIPViewProps = RTCVideoViewProps & {
  fallbackView?: React.ReactNode;
  iosPIP?: RTCIOSPIPOptions;
};

const RTCPIPView = forwardRef<unknown, RTCPIPViewProps>(props => <RTCView {...props} />);

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function startIOSPIP() {}

// eslint-disable-next-line @typescript-eslint/no-empty-function
export function stopIOSPIP() {}

export default RTCPIPView;
